var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1387 4.57479C13.1912 3.69769 14.7973 4.33145 14.9672 5.69094C15.4909 9.88068 15.4909 14.1193 14.9672 18.3091C14.7973 19.6685 13.1912 20.3023 12.1387 19.4252L7.798 15.8079C7.75307 15.7705 7.69643 15.75 7.63795 15.75H4C3.0335 15.75 2.25 14.9665 2.25 14V10C2.25 9.0335 3.0335 8.25 4 8.25H7.63795C7.69643 8.25 7.75307 8.22949 7.798 8.19205L12.1387 4.57479ZM13.4788 5.87699C13.456 5.69444 13.2403 5.60935 13.099 5.72712L8.75827 9.34438C8.44377 9.60647 8.04734 9.75 7.63795 9.75H4C3.86193 9.75 3.75 9.86193 3.75 10V14C3.75 14.1381 3.86193 14.25 4 14.25H7.63795C8.04734 14.25 8.44377 14.3935 8.75827 14.6556L13.099 18.2729C13.2403 18.3906 13.456 18.3056 13.4788 18.123C13.9871 14.0568 13.9871 9.94317 13.4788 5.87699Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2019 9.7019C17.4948 9.40901 17.9697 9.40901 18.2626 9.7019L19.5 10.9393L20.7374 9.7019C21.0303 9.409 21.5052 9.409 21.7981 9.7019C22.091 9.99479 22.091 10.4697 21.7981 10.7626L20.5607 12L21.7981 13.2374C22.091 13.5303 22.091 14.0052 21.7981 14.2981C21.5052 14.591 21.0303 14.591 20.7374 14.2981L19.5 13.0607L18.2626 14.2981C17.9697 14.591 17.4948 14.591 17.2019 14.2981C16.909 14.0052 16.909 13.5303 17.2019 13.2374L18.4393 12L17.2019 10.7626C16.909 10.4697 16.909 9.99479 17.2019 9.7019Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/Volume-off.124a16a41758c21aebff34bba103aba2.svg";
export { ForwardRef as ReactComponent };